import {
	preventDoubleClick
} from '../global/_doubleClick';

export const rememberMeForgotPassword = (params, returnHTML) => {
    var myCallback = () => {
            $("#forgotContinue").attr("href", params.continueURL);
            preventDoubleClick();
        },
        url = "/static/html/modals/_remember_me_forgot_password.html";
    $.ajax({
        url: url,
        success: function(html) {
            returnHTML(html, myCallback);
            return false;
        }
    });
};
